/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Vietnamese (Vietnam)
export default {
  'fabric.linkPicker.button.cancel': 'Hủy',
  'fabric.linkPicker.button.insert': 'Chèn',
  'fabric.linkPicker.button.save': 'Lưu',
  'fabric.linkPicker.clearLink': 'Xóa',
  'fabric.linkPicker.clearLinkText': 'Xóa văn bản',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {không tìm thấy kết quả} other {Đã tìm thấy {count,number} kết quả}}',
  'fabric.linkPicker.linkAriaLabel': 'Nhập hoặc dán liên kết vào trường',
  'fabric.linkPicker.linkHelperTextAriaLabel': 'Văn bản hỗ trợ hiển thị liên kết',
  'fabric.linkPicker.linkHelperTextLabel': 'Cung cấp tiêu đề hoặc mô tả cho liên kết này',
  'fabric.linkPicker.linkInvalid': 'Nhập URL hợp lệ.',
  'fabric.linkPicker.linkLabel': 'Liên kết',
  'fabric.linkPicker.linkPlaceholder': 'Dán liên kết',
  'fabric.linkPicker.linkTextAriaLabel': 'Văn bản hiển thị liên kết',
  'fabric.linkPicker.linkTextLabel': 'Văn bản hiển thị (không bắt buộc)',
  'fabric.linkPicker.linkTextPlaceholder': 'Văn bản cần hiển thị',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Đã xem gần đây',
  'fabric.linkPicker.listTitle.results': 'Kết quả',
  'fabric.linkPicker.search.error.description': 'Làm mới trang hoặc liên hệ với <a>Bộ phận hỗ trợ Atlassian</a> nếu sự cố vẫn tiếp diễn.',
  'fabric.linkPicker.search.error.heading': 'Chúng tôi gặp vấn đề khi tải dữ liệu.',
  'fabric.linkPicker.search.error.retry': 'Làm mới',
  'fabric.linkPicker.search.linkAriaLabel': 'Các đề xuất sẽ xuất hiện bên dưới khi bạn nhập thông tin vào trường',
  'fabric.linkPicker.search.linkLabel': 'Tìm kiếm hoặc dán liên kết',
  'fabric.linkPicker.search.linkPlaceholder': 'Tìm các liên kết gần đây hoặc dán một liên kết mới',
  'fabric.linkPicker.search.noResults.description': 'Hãy thử lại bằng cụm từ tìm kiếm khác.',
  'fabric.linkPicker.search.noResults.heading': 'Không tìm thấy bất kỳ nội dung nào phù hợp với yêu cầu tìm kiếm của bạn.',
  'fabric.linkPicker.status.submitting': 'Đang gửi',
  'fabric.linkPicker.time.message.updated': 'Đã cập nhật {time}',
  'fabric.linkPicker.time.message.viewed': 'Đã xem {time}',
  'fabric.linkPicker.unhandledError.description': 'Hãy thử tải lại trang.',
  'fabric.linkPicker.unhandledError.heading': 'Đã xảy ra lỗi!'
};